export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-swipe-cell/index.js